import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { GENERAL_STORE } from '../store'

export default {
  props: {
    dot: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      newDotStoreUnsubscribe: null,
    }
  },

  watch: {
    timeFrom: {
      handler(newVal, oldVal) {
        // Очередной мега костыль.
        // Если выбрано сейчас - устанавливаем в стейт соответсвующее состояние (нужно для пост обработчика, добавление минуты)
        this.setIsCurrentTime({
          dotIdx: this.thisDotIndex,
          isNow: this.isCurrentDate && newVal === this.currentDate.time,
        })

        // Если не найдено новое значение в массиве доступных, то указываем первое из них
        if (!this.availableTimes.find(time => time.value === newVal)) {
          try {
            this.updateDot({
              dot: this.dot,
              data: {
                key: 'timeFrom',
                value: this.availableTimes[0].value,
              },
            })
            if (oldVal && newVal === this.currentDate.time) return
            this.calculatePrice()
          } catch (e) {
            /* empty */
          }
        }
      },
      immediate: true,
    },
    // isNowChosen(newVal) {
    //   this.updateState({ key: 'isSendTimeDue', value: newVal })
    // },
    availableTimes(newVal) {
      // Если пулл времени по какой-либо причине оказался пустым - сбрасываем, устанавливаем минимальное время
      if (!newVal.length) {
        this.updateDot({
          dot: this.dot,
          data: {
            key: 'timeFrom',
            value: this.currentDate.time,
          },
        })
      }

      if (!newVal[0]?.value) return

      // Если не найдено выбранное время в массиве новых, то указываем первое из них
      if (!newVal.find(time => time.value === this.timeFrom)) {
        this.updateDot({
          dot: this.dot,
          data: {
            key: 'timeFrom',
            value: newVal[0].value,
          },
        })
      }
    },
  },
  computed: {
    ...mapState(GENERAL_STORE, ['base', 'form', 'currentDate', 'order']),
    ...mapGetters(GENERAL_STORE, [
      'getDotIndex',
      'isYandexForm',
      'minTimePickup',
      'minTimeDelivery',
    ]),

    dots() {
      return this.order.dots
    },

    timeFrom: {
      get() {
        return this.dot.timeFrom
      },
      set(value) {
        this.updateDot({ dot: this.dot, data: { key: 'timeFrom', value } })
        this.calculatePrice()
      },
    },
    isToday() {
      return this.dot.date === this.currentDate.clearedDate
    },
    isEdit() {
      return this.base.isEdit
    },
    isRestart() {
      return this.base.isRestart
    },
    thisDotIndex() {
      return this.getDotIndex(this.dot)
    },
    isPickUpDot() {
      return this.thisDotIndex === 0
    },
    prevDot() {
      if (!this.isPickUpDot) return this.dots[this.thisDotIndex - 1]
      return null
    },
    isCurrentDate() {
      return this.dot.date === this.currentDate.clearedDate
    },
    // isNowChosen() {
    //   return !(
    //     this.isYandexForm &&
    //     this.isToday &&
    //     this.availableTimes[0].value === this.dot.timeFrom
    //   )
    // },
    availableTimes() {
      let times = [...this.form.allTimes]
      const maximumTimeToChoose = this.dot.timeTo

      // Для админов возвращаем полный пул времен и для сегодня добавляем время сейчас
      if (this.base.isAdmin && this.isToday) {
        times.unshift({ value: this.currentDate.time, label: 'Сейчас' })
      }

      if (this.base.isAdmin) {
        // Исключаем все, что позднее "23:30" из пула
        times = this.addInitialTime(times).filter(time => time.value <= '23:30')

        return times
      }

      // ________________________________________________________________
      const minimalTimeToChoose = (() => {
        let minimal = '00:00'

        // Минимальное значение время "с" будет значение предыдущей точки
        if (this.prevDot && this.prevDot.date === this.dot.date) minimal = this.prevDot.timeFrom

        // Для случая сегодня и точки забора (prevDot === null) будет время из геттера, подробнее в самом геттере
        if (this.isToday && this.isPickUpDot)
          minimal = this.minTimePickup > minimal ? this.minTimePickup : minimal
        if (this.isToday && !this.isPickUpDot)
          minimal = this.minTimeDelivery > minimal ? this.minTimeDelivery : minimal

        // Для остальных случаев (точка забора не на сегодня) - 00:00
        return minimal
      })()

      times = times.filter(
        time => time.value >= minimalTimeToChoose && time.value < maximumTimeToChoose
      )

      // Если сегодняшяя дата и не редактирование добавляем время "Сейчас"
      if ((this.isToday && !this.isEdit) || (this.isToday && this.isRestart)) {
        times.unshift({ value: this.currentDate.time, label: 'Сейчас' })
      }

      times = this.addInitialTime(times)

      return times
    },
  },
  methods: {
    ...mapMutations(GENERAL_STORE, ['updateDot', 'updateState', 'setIsCurrentTime']),
    ...mapActions(GENERAL_STORE, ['calculatePrice']),
    addInitialTime(_times) {
      const times = [..._times]

      // initial значения имеются у точек только при редактировании заказа
      // если есть изначальное время у точки и день у точки остался изничальным
      // при этом не находим это время "от" в списке достпуных - добавляем в список изначальное значение
      // Добавляем для точки забора или если изначальное время не больше времени предыдущей точки
      if (
        this.dot.initialTimeFrom &&
        this.dot.date === this.dot.initialDate &&
        !times.find(time => time.value === this.dot.initialTimeFrom) &&
        (this.isPickUpDot || this.prevDot.timeFrom <= this.dot.initialTimeFrom)
      ) {
        times.unshift({
          value: this.dot.initialTimeFrom,
          label: this.dot.initialTimeFrom,
        })
      }

      return times
    },
  },
  mounted() {
    // console.log(this.dot.timeFrom)
    // При создании новой точки доставки (через кнопку "Добавить адрес")
    // Если у точки забора указано не "Сегодня" - ставим время в новой точке на "Неважно"
    this.newDotStoreUnsubscribe = this.$store.subscribe(mutation => {
      if (mutation.type === 'createDot') {
        if (this.isToday) {
          this.updateDot({
            dot: this.order.dots.at(-1),
            data: {
              key: 'timeFrom',
              // "сейчас"
              value: this.currentDate.time,
            },
          })
        }
      }
    })
  },

  beforeDestroy() {
    if (this.newDotStoreUnsubscribe) this.newDotStoreUnsubscribe()
  },
}
